export interface GsTokenModel{
    resource_id_slug: number | string,
    resource_type: string,
    token: string
}